import React, { useRef } from 'react'
import { IProps } from './Interface'
import { Button } from 'components'
import { Box, Avatar, Typography } from '@material-ui/core'
import useStyles from './Styles'

const AvatarSelect: React.FC<IProps> = ({ user, onAdd, onRemove, inProgress, disabled, ...props }) => {
  const ref = useRef<HTMLInputElement>()

  const classes = useStyles({ src: user.avatar })

  const handleOpenFiles = (event: React.MouseEvent<HTMLElement>) => {
    ref.current.click()
    event.stopPropagation()
  }

  return (
    <Box className={classes.root} {...props}>
      <Box className={classes.avatarContainer}>
        <Avatar
          className={classes.avatar}
          alt={`${user.firstName} ${user.lastName}`}
          src={user.avatar}
          id="avatar-preview-image"
          data-testid="avatar-preview"
        >
          {`${user.firstName?.charAt(0)}${user.lastName?.charAt(0)}`}
        </Avatar>
        {!disabled && user.avatar && (
          <Box className={classes.remove}>
            <Button
              flat
              bgColor="white"
              onClick={onRemove}
              disabled={inProgress}
              aria-labelledby={'c'}
              data-testid="remove-avatar-btn"
            >
              <Typography id={'aria-labelledby'}>Remove Image</Typography>
            </Button>
          </Box>
        )}
      </Box>

      <Box mt={2} hidden={disabled}>
        <Button
          textTransform="none"
          disabled={inProgress}
          onClick={handleOpenFiles}
          aria-labelledby="add-avatar-image-button"
        >
          <Typography id={'add-avatar-image-button'}>+ Add Profile Picture</Typography>
        </Button>
      </Box>

      <Box display="none">
        <input ref={ref} type="file" data-testid="input-avatar" onChange={onAdd} accept="image/*" />
      </Box>
    </Box>
  )
}

AvatarSelect.defaultProps = {
  user: {
    firstName: '',
    lastName: '',
    avatar: ''
  },
  onAdd: () => {},
  onRemove: () => {},
  inProgress: false
}

export default AvatarSelect
